module.exports = "<div id=\"viewPane\" class=\"instructionProcessingMatrix synPane\">\r\n    <div class=\"matrix\"></div>\r\n</div>\r\n";